import { IKnmListFilterExtraField } from '../interfaces/IKnmListFilterExtraField';

export const initialKnmListAdditionalFields: IKnmListFilterExtraField[] = [
  {
    id: 'disapprove',
    name: 'В согласовании отказано',
    isSelected: false,
    type: 'select',
  },
  {
    id: 'supervisionType',
    name: 'Вид государственного контроля (надзора)',
    isSelected: false,
    type: 'select',
    isSearchable: true,
    isClearable: true,
  },
  {
    id: 'approveRequiredType',
    name: 'Необходимость согласования',
    isSelected: false,
    type: 'select',
    isSearchable: false,
    isClearable: true,
    isMulti: false,
  },
  {
    id: 'hasViolations',
    name: 'Выявлены нарушения',
    isSelected: false,
    type: 'select',
  },
  {
    id: 'dataNotEqualEGRUL',
    name: 'Данные проверяемого лица не совпадают с БД ЕГРЮЛ',
    isSelected: false,
    type: 'select',
  },
  {
    id: 'startDate',
    name: 'Дата начала проведения КНМ',
    isSelected: false,
    type: 'date',
  },
  {
    id: 'startDateBetween',
    name: 'Дата начала проведения КНМ (интервал)',
    isSelected: false,
    type: 'date',
  },
  {
    id: 'approveDocRequestDate',
    name: 'Дата приказа органа прокуратуры о согласовании проведения КНМ',
    isSelected: false,
    type: 'date',
  },
  {
    id: 'approveDocOrderDate',
    name: 'Дата распоряжения или приказа руководителя органа контроля о проведении КНМ',
    isSelected: false,
    type: 'date',
  },
  {
    id: 'chlistFillingIndicationType',
    name: 'Индикация заполненности проверочных листов',
    isSelected: false,
    type: 'select',
  },
  {
    id: 'subjectInn',
    name: 'ИНН проверяемого лица',
    isSelected: false,
    type: 'text',
  },
  {
    id: 'knmAnnulled',
    name: 'КНМ аннулировано',
    isSelected: false,
    type: 'select',
  },
  {
    id: 'createdByMe',
    name: 'Мною созданные проверки',
    isSelected: false,
    type: 'select',
  },
  {
    id: 'subjectOrgName',
    name: 'Наименование проверяемого лица',
    isSelected: false,
    type: 'text',
  },
  {
    id: 'regType',
    name: 'Наличие проверяемого лица в реестрах',
    isSelected: false,
    type: 'select',
  },
  {
    id: 'planNum',
    name: 'Номер плана',
    isSelected: false,
    type: 'text',
  },
  {
    id: 'mspCategory',
    name: 'Категории субъекта МСП',
    isSelected: false,
    type: 'select',
  },
  {
    id: 'approveDocRequestNum',
    name: 'Номер приказа органа прокуратуры о согласовании проведения КНМ',
    isSelected: false,
    type: 'text',
  },
  {
    id: 'approveDocOrderNum',
    name: 'Номер распоряжения или приказа руководителя органа контроля о проведении КНМ',
    isSelected: false,
    type: 'text',
  },
  {
    id: 'objectOgrn',
    name: 'ОГРН проверяемого лица',
    isSelected: false,
    type: 'text',
  },
  {
    id: 'prosecutorOrganizations',
    name: 'Орган прокуратуры',
    isSelected: false,
    type: 'select',
    isMulti: true,
  },
  {
    id: 'dataSetNotInTime',
    name: 'Основные сведения КНМ заполнены несвоевременно',
    isSelected: false,
    type: 'select',
  },
  {
    id: 'deletedOnly',
    name: 'Показывать только удаленные проверки',
    isSelected: false,
    type: 'select',
  },
  {
    id: 'deletedInclude',
    name: 'Показывать удаленные проверки',
    isSelected: false,
    type: 'select',
  },
  {
    id: 'legalBasisDocName',
    name: 'Правовые основания проведения КНМ',
    isSelected: false,
    type: 'text',
  },
  {
    id: 'orderDone',
    name: 'Предписание исполнено',
    isSelected: false,
    type: 'select',
  },
  {
    id: 'recEmptyOrLate',
    name: 'Предписание не вынесено или вынесено с опозданием',
    isSelected: false,
    type: 'select',
  },
  {
    id: 'regLate',
    name: 'Регистрация проверки проведена с опозданием ',
    isSelected: false,
    type: 'select',
  },
  {
    id: 'resultEmpty',
    name: 'Результат КНМ отсутствует',
    isSelected: false,
    type: 'select',
  },
  {
    id: 'resultEmptyOrLate',
    name: 'Результат отсутствует или внесен с опозданием',
    isSelected: false,
    type: 'select',
  },
  {
    id: 'appealed',
    name: 'Решение обжаловано',
    isSelected: false,
    type: 'select',
  },
  {
    id: 'noPunishment',
    name: 'Сведения о привлечении к административной ответственности виновных лиц не вынесено',
    isSelected: false,
    type: 'select',
  },
  {
    id: 'approved',
    name: 'Сведения о согласовании проведения КНМ',
    isSelected: false,
    type: 'select',
  },
  {
    id: 'statuses',
    name: 'Статус КНМ',
    isSelected: false,
    type: 'select',
    isMulti: true,
  },
  {
    id: 'signed',
    name: 'Статус подписания',
    isSelected: false,
    type: 'select',
  },
  {
    id: 'pubStatuses',
    name: 'Статус публикации',
    isSelected: false,
    type: 'select',
    isMulti: true,
  },
  {
    id: 'subjectTypes',
    name: 'Тип субъекта проверки',
    isSelected: false,
    type: 'select',
    isMulti: true,
  },
  {
    id: 'notifyLate',
    name: 'Уведомление о проведении проверки с опозданием',
    isSelected: false,
    type: 'select',
  },
  {
    id: 'admLevel',
    name: 'Уровень КО',
    isSelected: false,
    type: 'select',
  },
  {
    id: 'erpId',
    name: 'Учетный номер КНМ',
    isSelected: false,
    type: 'text',
  },
  {
    id: 'inspectorFullName',
    name: 'ФИО лица, уполномоченного на проведение КНМ',
    isSelected: false,
    type: 'text',
  },
  {
    id: 'address',
    name: 'Адрес',
    isSelected: false,
    type: 'address',
  },
  {
    id: 'createPlanDate',
    name: 'Дата создания плана',
    isSelected: false,
    type: 'date',
  },
  {
    id: 'updatePlanDate',
    name: 'Дата последнего изменения плана',
    isSelected: false,
    type: 'date',
  },
  {
    id: 'requirementDetails',
    name: 'Реквизиты требования прокурора о проведении КНМ',
    isSelected: false,
    type: 'text',
  },
  {
    id: 'assignmentNumber',
    name: 'Номер поручения правительства о проведении КНМ',
    isSelected: false,
    type: 'text',
  },
  {
    id: 'assignmentDate',
    name: 'Дата поручения правительства о проведении КНМ',
    isSelected: false,
    type: 'date',
  },
  {
    id: 'assignmentDateBetween',
    name: 'Дата поручения правительства о проведении КНМ (интервал)',
    isSelected: false,
    type: 'date',
  },
  {
    id: 'responsibilityTypeCodes',
    name: 'Сведения о виде назначенного наказания решения, принятого по результатам КНМ',
    isSelected: false,
    type: 'select',
    isSearchable: false,
    isClearable: true,
    isMulti: true,
  },
  {
    id: 'amountOfPunishmentBetween',
    name: 'Сведения о размере наказания решения, принятого по результатам КНМ (интервал)',
    isSelected: false,
    type: 'text',
  },
];

export const isTestAdditionalField: IKnmListFilterExtraField = {
  id: 'isTest',
  name: 'Тестовый',
  isSelected: false,
  type: 'select',
};
